<template>
  <el-card class="!border-none" :body-style="{ height: '100%' }">
    <div class="w-full h-full overflow-y-auto">
      <div class="flex items-center h-36px" v-if="operateType">
        <p class="pl-10px border-l-2px text-20px border-$systemMainColor">{{ title }}</p>
      </div>
      <div class="flex items-center h-36px" v-else>
        <el-button type="primary" size="small" class="mr-10px" @click="cancel">返回</el-button>
        <p class="pl-10px title-left-border-back border-l-2px text-20px">{{ title }}</p>
      </div>
      <el-form
        class="my-20px"
        :model="formData"
        :rules="formRules"
        ref="formRef"
        label-width="150px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="采集任务名称" prop="name">
              <el-input
                size="small"
                maxlength="50"
                placeholder="请输入"
                v-model="formData.name"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入库栏目" prop="columnId">
              <el-select
                ref="formSelectTree"
                popper-class="gathet-task-dig-select-tree"
                class="w-full"
                size="small"
                v-model="formData.columnId"
                placeholder="请选择"
                @visible-change="visibleSelectChange"
                :disabled="!operateType"
              >
                <el-option
                  :label="formData.columnName"
                  :value="formData.columnId"
                  :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
                >
                  <el-tree
                    :props="{
                      label: 'name',
                      children: 'child',
                    }"
                    class="text-white max-h-274px overflow-x-hidden tree-scrollbar-style"
                    ref="treeRef"
                    node-key="id"
                    highlight-current
                    :data="treeData"
                    @node-click="formNodeClick"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandedKeys"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="采集周期" prop="intevalType">
              <div class="flex items-center">
                <el-input-number
                  size="small"
                  type="number"
                  v-model="formData.intevalValue"
                  :min="1"
                  :step="1"
                  step-strictly
                  class="min-w-90px"
                  :disabled="!operateType"
                ></el-input-number>
                <el-select
                  size="small"
                  v-model="formData.intevalType"
                  placeholder="请选择"
                  clearable
                  class="ml-10px"
                  :disabled="!operateType"
                >
                  <el-option label="小时" :value="0"></el-option>
                  <el-option label="天" :value="1"></el-option>
                  <el-option label="周" :value="2"></el-option>
                  <el-option label="月" :value="3"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="采集url地址" prop="url">
              <el-input
                size="small"
                maxlength="200"
                placeholder="请输入"
                v-model="formData.url"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="采集页数" prop="pageCount">
              <el-input
                size="small"
                maxlength="200"
                placeholder="请输入"
                v-model="formData.pageCount"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分页跳转类型" prop="pageJumpType">
              <el-select
                v-model.trim="formData.pageJumpType"
                class="mr-10px"
                clearable
                popper-class="select-popper"
                placeholder="栏目类别"
              >
                <el-option label="url跳转" :value="0"></el-option>
                <el-option label="form提交" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="详情Xpath" prop="detailJumpXpath">
              <el-input
                size="small"
                maxlength="200"
                placeholder="请输入"
                v-model="formData.detailJumpXpath"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详情Xpath v8配置" prop="detailJumpXpathV8">
              <el-input
                size="small"
                type="textarea"
                placeholder="请输入"
                v-model="formData.detailJumpXpathV8"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分页v8配置" prop="urlPageV8">
              <el-input
                size="small"
                type="textarea"
                placeholder="请输入"
                v-model="formData.urlPageV8"
                clearable
                :disabled="!operateType"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="flex items-center h-36px">
        <p class="pl-10px border-l-2px text-20px border-$systemMainColor">采集字段设置</p>
      </div>
      <div class="mt-20px" v-if="operateType">
        <el-button type="primary" size="small" @click="addSetPage">新增</el-button>
      </div>
      <el-table
        border
        stripe
        :data="tableDataPage"
        :height="operateType ? 'calc(100% - 464px)' : 'calc(100% - 352px)'"
        :highlight-current-row="true"
        ref="tableRef"
        class="mt-20px"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="参数名称" prop="key" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              size="small"
              maxlength="50"
              placeholder="请输入"
              v-model="scope.row.key"
              :disabled="!operateType"
              class="table-input"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="参数值" prop="value" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              size="small"
              placeholder="请输入"
              v-model="scope.row.value"
              :disabled="!operateType"
              class="table-input"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="是否页号" prop="isPageNo" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              size="small"
              v-model="scope.row.isPageNo"
              placeholder="请选择"
              class="w-full table-select"
              :disabled="!operateType"
            >
              <el-option
                v-for="item in pageNumber"
                :value="item.value"
                :label="item.displayName"
                :key="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="deletePageData(scope)" :disabled="!operateType">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-20px" v-if="operateType">
        <el-button type="primary" size="small" @click="addSet">新增</el-button>
      </div>
      <el-table
        border
        stripe
        :data="tableData"
        :height="operateType ? 'calc(100% - 464px)' : 'calc(100% - 352px)'"
        :highlight-current-row="true"
        ref="tableRef"
        class="mt-20px"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="采集字段Xpath" prop="xPath" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              size="small"
              maxlength="200"
              placeholder="请输入"
              v-model="scope.row.xPath"
              :disabled="!operateType"
              class="table-input"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="v8配置" prop="v8" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              size="small"
              placeholder="请输入"
              v-model="scope.row.v8"
              :disabled="!operateType"
              class="table-input"
              type="textarea"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="栏目字段名称" prop="metaId" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              size="small"
              v-model="scope.row.metaId"
              placeholder="请选择"
              class="w-full table-select"
              :disabled="!operateType"
            >
              <el-option
                v-for="item in columnFieldNameList"
                :value="item.id"
                :label="item.displayName"
                :key="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button size="mini" @click="deleteData(row)" :disabled="!operateType">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-center mt-20px" v-if="operateType">
        <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { SpiderConfigApi, EditTemplateMetaApi } from '@wiz-api/workbench'

const spiderConfigApi = new SpiderConfigApi()
const editTemplateMetaApi = new EditTemplateMetaApi()

export default {
  name: 'GathetTaskDig',
  props: {
    operateType: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
    source: {
      type: Number,
      default: 0,
    },
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    detailData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    const checkSeq = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error('采集页数不能为空'))
        return
      }
      if (!_.isSafeInteger(_.toNumber(value)) || value < 1) {
        callback(new Error('采集页数必须为大于0的正整数'))
        return
      }
      callback()
    }
    return {
      formData: {
        name: '',
        columnName: '',
        columnId: '',
        intevalValue: 1,
        intevalType: '',
        url: '',
        setting: '',

        pageCount: null,
        pageJumpType: null,
        pageJumpParam: '',
        detailJumpXpath: '',
        detailJumpXpathV8: '',
      },
      defaultExpandedKeys: [],
      formRules: {
        name: [{ required: true, message: '请输入采集任务名称', trigger: 'blur' }],
        columnId: [{ required: true, message: '请选择入库栏目', trigger: ['blur', 'change'] }],
        intevalType: [
          { required: true, message: '请选择采集周期单位', trigger: ['blur', 'change'] },
        ],
        url: [{ required: true, message: '请输入采集url地址', trigger: 'blur' }],
        pageCount: [{ required: true, validator: checkSeq, trigger: 'change' }],
        pageJumpType: [{ required: true, message: '请输入分页跳转类型', trigger: 'blur' }],
        detailJumpXpath: [{ required: true, message: '请输入详情xPath', trigger: 'blur' }],
        detailJumpXpathV8: [
          { required: this.source !== 2, message: '请输入详情xPath v8配置', trigger: 'blur' },
        ],
      },
      tableData: [],
      tableDataPage: [],
      tableLoading: false,
      saveLoading: false,
      columnFieldNameList: [],
      pageNumber: [
        {
          value: true,
          displayName: '是',
        },
        {
          value: false,
          displayName: '否',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  methods: {
    addSet() {
      this.tableData.push({ xPath: '', metaId: '', v8: '' })
    },
    addSetPage() {
      this.tableDataPage.push({ key: '', value: '', isPageNo: false })
    },
    deletePageData(scope) {
      this.tableDataPage.splice(scope.$index, 1)
    },
    deleteData(row) {
      this.tableData = this.tableData.filter((it) => {
        return it.id !== row.id
      })
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const data = _.pick(_.cloneDeep(this.formData), [
            'name',
            'intevalValue',
            'intevalType',
            'url',
            'setting',
            'columnId',
            'id',
            'pageCount',
            'pageJumpType',
            'pageJumpParam',
            'detailJumpXpath',
            'detailJumpXpathV8',
            'urlPageV8',
            'pageJumpParam',
          ])
          data.setting = JSON.stringify(this.tableData)
          data.pageJumpParam = JSON.stringify(this.tableDataPage)
          let tip = ''
          if (this.mode === 'create') {
            delete data.id
            tip = '新增成功'
            const [err, res] = await await spiderConfigApi.add({ body: data })
            if (!res) {
              this.$message.warning('采集任务名称或列表url地址重复')
            } else {
              this.$message.success(tip)
              this.cancel()
              this.$emit('success')
            }
          } else if (this.mode === 'update') {
            tip = '编辑成功'
            const [err, res] = await spiderConfigApi.update({ body: data })
            if (!res) {
              this.$message.warning('采集任务名称或列表url地址重复')
            } else {
              this.$message.success(tip)
              this.cancel()
              this.$emit('success')
            }
          }
        }
      })
    },
    visibleSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.treeRef && this.$refs.treeRef.setCurrentKey(this.formData.columnId) // 设置选中元素
          this.defaultExpandedKeys = [this.formData.columnId]
        } else {
          const nodeDatas = this.$refs.treeRef && this.$refs.treeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    formNodeClick(node) {
      this.$set(this.formData, 'columnId', node.id)
      this.$set(this.formData, 'columnName', node.name)
      this.formData.columnId = node.id
      this.formData.columnName = node.name
      this.$refs.formSelectTree.blur()
      this.editTemplateMeta()
      if (this.detailData.columnId === node.id) return
      this.tableData = this.tableData.map((it) => {
        it.columnFieldName = ''
        return it
      })
    },
    cancel() {
      this.$emit('close')
    },
    async editTemplateMeta() {
      const [err, res] = await editTemplateMetaApi.getEditTemplateMeta({
        columnId: this.formData.columnId,
      })
      if (!err) {
        this.columnFieldNameList = res
      }
    },
  },
  created() {},
  async mounted() {
    this.formData = _.cloneDeep(this.detailData)
    if (this.title !== '新增采集任务') {
      this.tableLoading = true
      await this.editTemplateMeta()
      this.tableLoading = false
    }
    this.tableData = this.formData.setting ? JSON.parse(this.formData.setting) : []
    this.tableDataPage = this.formData.pageJumpParam ? JSON.parse(this.formData.pageJumpParam) : []
    this.$nextTick(() => {
      this.$refs.formRef && this.$refs.formRef.clearValidate() // 清除新增表单验证
    })
  },
}
</script>

<style lang="scss" scoped>
.tree-scrollbar-style::-webkit-scrollbar {
  width: 6px;
}
::v-deep .el-tree-node__content {
  height: 36px;
}
::v-deep {
  .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
  .table-input,
  .table-select {
    .el-input__inner {
      border: none;
      padding: 0;
      background: transparent;
      &:focus,
      &:hover,
      &:active {
        background: transparent;
      }
    }
  }
}
::v-deep .table-select {
  .el-icon-arrow-up {
    line-height: 36px !important;
  }
}
</style>
<style lang="scss">
.gathet-task-dig-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
